import { createClient } from '@supabase/supabase-js';

// hanmaeum 과 "동일한" Supabase 프로젝트를 바라봐야 estimate_extras 테이블을 공유한다.
// CRA(react-scripts) 이므로 env 는 REACT_APP_ 접두사 + process.env 로 읽는다.
// .env(.local) 에 아래 두 값을 hanmaeum 과 같은 값으로 채운다:
//   REACT_APP_SUPABASE_URL=...
//   REACT_APP_SUPABASE_ANON_KEY=...
const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

/** URL/KEY 가 모두 채워졌는지 */
export const isSupabaseConfigured = Boolean(url && anonKey);

/** 설정된 경우에만 클라이언트 생성 (없으면 null → 호출부에서 조용히 skip) */
export const supabase = isSupabaseConfigured ? createClient(url, anonKey) : null;
